var _rect, _rect2, _rect3, _line, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 0.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 0.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 0.75,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.6499,
    x2: 4.6499,
    y2: 22,
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94341 10.7994C9.83232 10.8814 9.80873 11.0379 9.89072 11.149C9.97271 11.2601 10.1292 11.2837 10.2403 11.2017L9.94341 10.7994ZM15.7334 6.83691L15.5849 6.63577L9.94341 10.7994L10.0919 11.0006L10.2403 11.2017L15.8819 7.03806L15.7334 6.83691Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2479 10.8065C10.14 10.7202 9.98272 10.7377 9.89647 10.8455C9.81022 10.9533 9.82771 11.1107 9.93553 11.1969L10.2479 10.8065ZM15.5918 15.4014L15.748 15.2061L10.2479 10.8065L10.0917 11.0017L9.93553 11.1969L15.4356 15.5966L15.5918 15.4014Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarleft);
export default __webpack_public_path__ + "static/media/sidebarleft.a8ae799784d174fdd09aceec9e83090a.svg";
export { ForwardRef as ReactComponent };